import React from 'react';
import styled, { css } from 'styled-components';

const Node = (props: INodePropTypes) => {
  const { first, last, isCurrent } = props;

  return (
    <NodeWrapper>
      <Line firstOrLast={first} />
      <Circle>
        <CircleBackground selected={isCurrent} />
      </Circle>
      <Line firstOrLast={last} />
    </NodeWrapper>
  );
};
const NodeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: stretch;
`;
const Circle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 100%;
  border: solid 3px #a4bad0;
`;
const CircleBackground = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  ${props =>
    props.selected &&
    css`
      background-color: #ede8e4;
    `}
`;
const Line = styled.div`
  flex: 1;
  height: 1px;
  border: solid 3px #627d98;
  ${props =>
    props.firstOrLast &&
    css`
      border-color: transparent;
    `}
`;
interface INodePropTypes {
  first: boolean;
  last: boolean;
  isCurrent: boolean;
}

export default Node;
